

  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import moment from "moment";
  import FormGroup from "@/components/form/FormGroup.vue";
  import FormDateRangePicker from "@/components/form/FormDateRangePicker.vue";
  import ManagerScheduler from "@/views/scheduler/ManagerScheduler.vue";
  import SchedulerViewSelect from "@/components/scheduler/schedulerSelects/SchedulerViewSelect.vue";
  import ProjectScheduler from "@/views/scheduler/ProjectScheduler.vue";
  import ContractorScheduler from "@/views/scheduler/ContractorScheduler.vue";
  import ManagersMultiselect from "@/components/autocompleteMultiselects/ManagersMultiselect.vue";
  import ProjectsMultiselect from "@/components/autocompleteMultiselects/ProjectsMultiselect.vue";
  import ProjectModalWithButton from "@/components/companyProjects/ProjectModalWithButton.vue";
  import ContractorsMultiselect from "@/components/autocompleteMultiselects/ContractorsMultiselect.vue";
  import FilterIcon from "@/components/icons/FilterIcon.vue";
  import TabNotificationBubble from "@/components/common/TabNotificationBubble.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import DropdownOption from "@/entities/DropdownOption";
  import DateRange from "@/entities/scheduler/DateRange";
  import Checkbox from "@/components/form/Checkbox.vue";
  import { Company, User } from "@/generated/graphql";
  import Roles from "@/entities/Roles";
  import { Project } from "@/generated/graphql";
  import RangeChangedPayload from "@/entities/scheduler/RangeChangedPayload";
  import getContractorsMultiselectConditions from "@/helpers/getContractorsMultiselectConditions";
  import GET_PROJECTS from "@/apollo/scheduler/GetProjects.gql";
import SchedulerItemEntities from "@/entities/scheduler/SchedulerItemEntities";
import ContractorFilter from "@/components/scheduler/additionalFilters/ContractorFilter.vue";
//@ts-ignore
  @Component({
    components: {
      ManagerScheduler,
      ProjectScheduler,
      ContractorScheduler,
      FormDateRangePicker,
      SchedulerViewSelect,
      FormGroup,
      Checkbox,
      ManagersMultiselect,
      ProjectsMultiselect,
      ContractorsMultiselect,
      FilterIcon,
      TabNotificationBubble,
      UiButton,
      ProjectModalWithButton,
      ContractorFilter
    },
    apollo: {
    projects: {
      query: GET_PROJECTS,
      update: data => data.project,
      skip: true,
    }
  }
  })
  export default class CompanyScheduler extends Vue {
    @Prop({type: Object, required: true}) readonly currentUser!: User;
    @Prop({type: Object, required: true}) readonly company!: Company;


  schedulerItemEntities = SchedulerItemEntities;
    showManagers: boolean = true;
    _showActivities: boolean =false;
    showProjects: boolean = false;
    showContractors: boolean = false;
    locations: DropdownOption[] = [];
    schedulerView = [this.managerViewOption];
    schedulerScale:{id: string, name: string}[] = [];
    appliedFiltersNumber: string = "";

    projects: Project[] = [];
    selectedContractorsIds: string[] = [];
    selectedProjectsIds: string[] = [];
    selectedManagersIds: string[] = [];

    showAdditionalFilters: boolean = false
    rangeStart: Date = new Date();
    rangeEnd: Date = moment(this.rangeStart).add(1, 'M').toDate();
    shouldClearFilters: boolean = false;

    showActivitiesCheckbox = {
      name: "Show Tasks",
      id: "showActivities",
      selected: false,
    }

    @Watch("schedulerView")
    chooseView() {
      switch(this.schedulerView[0].id) {
        case "View by managers":
          this.switchToManagers();
          break;
        case "View by projects":
          this.switchToProjects();
          break;
        case "View by contractors":
          this.switchToContractors();
          break;
      }
    }

    @Watch("showActivities")
    showActivitiesToggle(): void {
      this.$emit("showActivitiesToggle", this.showActivities)
    }
 
    get isAdmin(): boolean {
      return this.currentUser.role === Roles.ADMIN;
    }

    get showManagersSelect(): boolean {
      return this.showManagers && this.isAdmin;
    }

    get managerViewOption(): DropdownOption {
      return this.isAdmin
        ? {name: "View by managers", id: "View by managers"}
        : {name: "My schedule", id: "View by managers"};
    }

    get dateRange(): DateRange {
      return {
        startDate: this.rangeStart,
        endDate: this.rangeEnd,
      }
    }

    get showAppliedFiltersBubble(): boolean {
      return this.showManagers || this.showProjects
        ? true
        : Boolean(this.appliedFiltersNumber);
    }

    get contractorsMultiselectConditions(): Object | undefined {
      return getContractorsMultiselectConditions(this.currentUser.role);
    }

    get showFilterIcon(): boolean {
      return this.isAdmin || !this.showManagers && !this.isAdmin;
    }

    get showActivities(): boolean {
      this._showActivities = this.showActivitiesCheckbox.selected;
      return this.showActivitiesCheckbox.selected;
    }

    handleDateRangeChange(date: DateRange) {
      this.rangeStart = date.startDate;
      this.rangeEnd = date.endDate;
    }

    rangeChanged(data: RangeChangedPayload): void {
      this.rangeStart = data.start;
      this.rangeEnd = data.end;
    }

    clearSelectedEntities(): void {
      this.selectedContractorsIds = [];
      this.selectedProjectsIds = [];
      this.selectedManagersIds = [];
    }

    switchToManagers(): void {
      this.clearSelectedEntities();
      this.showProjects = false;
      this.showContractors = false
      this.showManagers = true;
      this.clearAdditionalFiltersNumber();
    }

    switchToProjects(): void {
      this.clearSelectedEntities();
      this.showManagers = false;
      this.showContractors = false;
      this.showProjects = true;
      this.clearAdditionalFiltersNumber();
    }

    switchToContractors(): void {
      this.clearSelectedEntities();
      this.showManagers = false;
      this.showProjects = false;
      this.showContractors = true;
      this.clearAdditionalFiltersNumber();
    }

    toggleAdditionalFilters(): void {
      this.showAdditionalFilters = !this.showAdditionalFilters;
    }

    clearAdditionalFiltersNumber(): void {
      this.showAdditionalFilters = false;
      this.appliedFiltersNumber = "";
    }

    handleAppliedFiltersChanged(num: number): void {
      this.appliedFiltersNumber = num ? num.toString(): "";
    }

    handleChosenProjectsUpdated(projectIds: string[]): void {
      this.selectedProjectsIds = projectIds;
    }

    handleClearFilters(): void {
      this.shouldClearFilters = true;
    }

    handleFiltersReset(): void {
      this.shouldClearFilters = false;
      this.rangeStart = new Date();
      this.rangeEnd = moment(this.rangeStart).add(1, 'M').toDate();
    }

    handleManagerFiltersReset(): void {
      this.selectedManagersIds = [];
      this.handleFiltersReset();
    }

    handleProjectFiltersReset(): void {
      this.selectedProjectsIds = [];
      this.handleFiltersReset();
    }

    handleContractorFiltersReset(): void {
      this.selectedContractorsIds = [];
      this.handleFiltersReset();
    }
  }
